import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { CookieDetail } from '@/app/types/cookieConsentType'
import { useTranslation } from '@/app/i18n/client'
import { useState } from 'react'

interface CookiesSubModalProps {
  cookieDetails: CookieDetail[] | undefined
}

const CookiesSubModal = ({ cookieDetails }: CookiesSubModalProps) => {
  const { t } = useTranslation()
  const [isSmallModalOpen, setIsSmallModalOpen] = useState(false)

  const onSmallToggle = () => {
    setIsSmallModalOpen(!isSmallModalOpen)
  }

  return (
    <div className="mx-5 my-2 ">
      <div className="border rounded-md">
        <div
          className="flex items-center justify-between px-5 h-[44px] py-[1px] cursor-pointer transition-all duration-300 ease-in-out"
          onClick={onSmallToggle}
        >
          <label className="font-medium cursor-pointer">
            {t('Fructidor.com')}
          </label>
          <span className="rounded-full flex items-center justify-center  hover:bg-[#F3F5F6] h-[35px] w-[35px] bg-slate-50">
            {isSmallModalOpen ? (
              <ExpandLessIcon className="text-[#6b6b6b]" />
            ) : (
              <ExpandMoreIcon className="text-[#6b6b6b]" />
            )}
          </span>
        </div>
        {isSmallModalOpen && (
          <div
            className={`border-t flex flex-col gap-4 transition  divide-y divide-[#E5E7EB] px-5 py-3`}
          >
            {cookieDetails &&
              cookieDetails?.map((cookie, index) => (
                <div
                  key={index}
                  className="group hover:bg-[#fafafa] p-3 rounded-md transition"
                >
                  <h4 className="font-medium text-sm transition">
                    {cookie.name}
                  </h4>
                  <p className="text-sm text-[#8b8b8b] mt-2">
                    {t(cookie.description)}
                  </p>
                  <div className="grid grid-cols-3 gap-2 mt-2 text-xs">
                    <div>
                      <p className="text-[#6b6b6b] ">{t('Type')}</p>
                      <p>{t(cookie.type)}</p>
                    </div>
                    <div>
                      <p className="text-[#6b6b6b] ">{t('Duration')}</p>
                      <p>{t(cookie.duration)}</p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default CookiesSubModal
